var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-layout" }, [
    _c(
      "div",
      { staticClass: "md-layout-item" },
      [
        _c(
          "md-card",
          [
            _c(
              "md-card-header",
              { staticClass: "md-card-header-icon md-card-header-warning" },
              [
                _c(
                  "div",
                  { staticClass: "card-icon" },
                  [_c("md-icon", [_vm._v("draft")])],
                  1
                ),
              ]
            ),
            this.selectedTeamMemberInvoiceIds.length && !_vm.isTeamMember
              ? _c("div", { staticClass: "bulk-section" }, [
                  _c("div", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(this.selectedTeamMemberInvoiceIds.length) +
                        " invoice" +
                        _vm._s(
                          this.selectedTeamMemberInvoiceIds.length > 1
                            ? "s"
                            : ""
                        ) +
                        "\n                    selected.\n                "
                    ),
                  ]),
                  _c(
                    "div",
                    [
                      !_vm.isReadOnlyUser
                        ? _c("approve-invoice-button", {
                            attrs: {
                              "is-bulk": true,
                              "bulk-team-member-invoice-ids":
                                _vm.selectedTeamMemberInvoiceIds,
                            },
                            on: { invoiceBulkApprove: _vm.handleBulkApprove },
                          })
                        : _vm._e(),
                      !_vm.isReadOnlyUser && !_vm.isTeamMember
                        ? _c("send-draft-invoice-button", {
                            directives: [
                              {
                                name: "feature",
                                rawName: "v-feature",
                                value:
                                  _vm.FEATURE_NAMES
                                    .TeamMemberInvoiceDraftApproval,
                                expression:
                                  "FEATURE_NAMES.TeamMemberInvoiceDraftApproval",
                              },
                            ],
                            staticClass: "bulk-send-draft",
                            attrs: {
                              "bulk-team-member-invoice-ids":
                                _vm.selectedTeamMemberInvoiceIds,
                              "is-bulk": true,
                            },
                            on: {
                              bulkDraftInvoicesSent: _vm.updateBulkDraftInvoice,
                            },
                          })
                        : _vm._e(),
                      _c("delete-invoice-button", {
                        attrs: {
                          "is-bulk": true,
                          "bulk-team-member-invoice-ids":
                            _vm.selectedTeamMemberInvoiceIds,
                        },
                        on: { invoiceBulkDelete: _vm.handleBulkDelete },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              [
                _c(
                  "md-table",
                  {
                    class: [
                      "context-menu-support",
                      "custom-paginated-table",
                      { "table-margin": _vm.isListLoading },
                    ],
                  },
                  [
                    _c(
                      "md-table-row",
                      [
                        _c(
                          "md-table-head",
                          [
                            _c("md-checkbox", {
                              staticClass: "shipment-checkbox checkbox-head",
                              on: {
                                change: function ($event) {
                                  return _vm.onSelectAll(_vm.isSelectAll)
                                },
                              },
                              model: {
                                value: _vm.isSelectAll,
                                callback: function ($$v) {
                                  _vm.isSelectAll = $$v
                                },
                                expression: "isSelectAll",
                              },
                            }),
                          ],
                          1
                        ),
                        !_vm.$root.isDesktop
                          ? _c("md-table-head", [_vm._v("Status")])
                          : _vm._e(),
                        _c("md-table-head", [_vm._v("Invoice Number")]),
                        _vm.$root.isDesktop
                          ? _c("md-table-head", [_vm._v("Team Member")])
                          : _vm._e(),
                        _vm.$root.isDesktop
                          ? _c(
                              "md-table-head",
                              { attrs: { "md-numeric": "" } },
                              [_vm._v("Adjustments")]
                            )
                          : _vm._e(),
                        _vm.$root.isDesktop
                          ? _c(
                              "md-table-head",
                              { attrs: { "md-numeric": "" } },
                              [_vm._v("Make Up")]
                            )
                          : _vm._e(),
                        _vm.$root.isDesktop
                          ? _c(
                              "md-table-head",
                              { attrs: { "md-numeric": "" } },
                              [_vm._v("Pro Rata Minimum")]
                            )
                          : _vm._e(),
                        _vm.$root.isDesktop
                          ? _c(
                              "md-table-head",
                              { attrs: { "md-numeric": "" } },
                              [_vm._v("Minimum")]
                            )
                          : _vm._e(),
                        _vm.$root.isDesktop
                          ? _c(
                              "md-table-head",
                              { attrs: { "md-numeric": "" } },
                              [_vm._v("Subtotal")]
                            )
                          : _vm._e(),
                        _vm.$root.isDesktop
                          ? _c(
                              "md-table-head",
                              { attrs: { "md-numeric": "" } },
                              [_vm._v("Tax")]
                            )
                          : _vm._e(),
                        _c("md-table-head", { attrs: { "md-numeric": "" } }, [
                          _vm._v("Total"),
                        ]),
                        _vm.$root.isDesktop
                          ? _c("md-table-head", [_vm._v("Status")])
                          : _vm._e(),
                        _vm.$root.isDesktop && !_vm.isReadOnlyUser
                          ? _c("md-table-head", [_vm._v("Actions")])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._l(_vm.invoicesList, function (invoice) {
                      return _c(
                        "md-table-row",
                        { key: invoice.invoiceId },
                        [
                          invoice.status === _vm.onHoldStatus
                            ? _c("md-tooltip", {
                                staticClass: "on-hold-tooltip",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.onHoldToolTip(invoice.onHoldUntilDate)
                                  ),
                                },
                              })
                            : _vm._e(),
                          _c(
                            "md-table-cell",
                            [
                              invoice.status !== _vm.onHoldStatus
                                ? _c("md-checkbox", {
                                    staticClass: "shipment-checkbox",
                                    attrs: {
                                      value: invoice.teamMemberInvoiceId,
                                    },
                                    model: {
                                      value: _vm.selectedTeamMemberInvoiceIds,
                                      callback: function ($$v) {
                                        _vm.selectedTeamMemberInvoiceIds = $$v
                                      },
                                      expression:
                                        "selectedTeamMemberInvoiceIds",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          !_vm.$root.isDesktop
                            ? _c(
                                "md-table-cell",
                                [
                                  _c("payment-status-button", {
                                    attrs: {
                                      "show-mobile-style": true,
                                      "invoice-details": invoice,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "md-table-cell",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "invoice-ref",
                                  attrs: {
                                    to: {
                                      name: "Team Member Invoice Details",
                                      params: {
                                        invoiceId: invoice.teamMemberInvoiceId,
                                      },
                                    },
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(invoice.invoiceNumber) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.$root.isDesktop
                            ? _c("md-table-cell", [
                                _vm._v(_vm._s(invoice.teamMember.fullName)),
                              ])
                            : _vm._e(),
                          _vm.$root.isDesktop
                            ? _c(
                                "md-table-cell",
                                { attrs: { "md-numeric": "" } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          invoice.totalAdjustments,
                                          invoice.currency
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.$root.isDesktop
                            ? _c(
                                "md-table-cell",
                                { attrs: { "md-numeric": "" } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          invoice.totalMinimumPay,
                                          invoice.currency
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.$root.isDesktop
                            ? _c(
                                "md-table-cell",
                                { attrs: { "md-numeric": "" } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          invoice.proRataAmount,
                                          invoice.currency
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.$root.isDesktop
                            ? _c(
                                "md-table-cell",
                                { attrs: { "md-numeric": "" } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          invoice.weeklyMinimum,
                                          invoice.currency
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.$root.isDesktop
                            ? _c(
                                "md-table-cell",
                                { attrs: { "md-numeric": "" } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          invoice.subTotal,
                                          invoice.currency
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.$root.isDesktop
                            ? _c(
                                "md-table-cell",
                                { attrs: { "md-numeric": "" } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          invoice.totalTax,
                                          invoice.currency
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("md-table-cell", { attrs: { "md-numeric": "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("currency")(
                                  invoice.total,
                                  invoice.currency
                                )
                              )
                            ),
                          ]),
                          _vm.$root.isDesktop
                            ? _c(
                                "md-table-cell",
                                [
                                  _c("payment-status-button", {
                                    attrs: {
                                      "invoice-details": invoice,
                                      disabled: true,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isReadOnlyUser
                            ? _c(
                                "md-table-cell",
                                [
                                  !_vm.isReadOnlyUser &&
                                  invoice.status !== _vm.onHoldStatus
                                    ? _c("approve-invoice-button", {
                                        attrs: {
                                          "invoice-id":
                                            invoice.teamMemberInvoiceId,
                                        },
                                        on: {
                                          invoiceApproved:
                                            _vm.handleApproveInvoice,
                                        },
                                      })
                                    : _vm._e(),
                                  !_vm.isReadOnlyUser &&
                                  !_vm.isTeamMember &&
                                  invoice.status !== _vm.onHoldStatus
                                    ? _c("send-draft-invoice-button", {
                                        directives: [
                                          {
                                            name: "feature",
                                            rawName: "v-feature",
                                            value:
                                              _vm.FEATURE_NAMES
                                                .TeamMemberInvoiceDraftApproval,
                                            expression:
                                              "FEATURE_NAMES.TeamMemberInvoiceDraftApproval",
                                          },
                                        ],
                                        attrs: {
                                          "invoice-id":
                                            invoice.teamMemberInvoiceId,
                                          "last-draft-sent-time":
                                            invoice.lastDraftEmailDateSent,
                                          "draft-has-been-sent":
                                            invoice.draftEmailHasBeenSent,
                                          "new-draft-cost-added":
                                            invoice.newDraftCostAdded,
                                        },
                                      })
                                    : _vm._e(),
                                  !_vm.isReadOnlyUser
                                    ? _c("generate-pdf-button", {
                                        attrs: {
                                          "invoice-id":
                                            invoice.teamMemberInvoiceId,
                                          "payment-summary": true,
                                        },
                                      })
                                    : _vm._e(),
                                  !_vm.isReadOnlyUser
                                    ? _c("generate-excel-button", {
                                        attrs: {
                                          "invoice-id":
                                            invoice.teamMemberInvoiceId,
                                        },
                                      })
                                    : _vm._e(),
                                  !_vm.isTeamMember
                                    ? _c("delete-invoice-button", {
                                        attrs: {
                                          "invoice-id":
                                            invoice.teamMemberInvoiceId,
                                        },
                                        on: {
                                          invoiceDeleted:
                                            _vm.handleDeleteInvoice,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    _vm.totals && _vm.invoicesList.length > 0
                      ? _c(
                          "md-table-row",
                          [
                            _c("md-table-cell"),
                            !_vm.$root.isDesktop
                              ? _c("md-table-cell")
                              : _vm._e(),
                            _c(
                              "md-table-cell",
                              { staticClass: "totals-bold" },
                              [_vm._v("Totals")]
                            ),
                            _vm.$root.isDesktop
                              ? _c("md-table-cell")
                              : _vm._e(),
                            _vm.$root.isDesktop
                              ? _c(
                                  "md-table-cell",
                                  {
                                    staticClass: "totals-bold",
                                    attrs: { "md-numeric": "" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.totals.totalAdjustments,
                                            _vm.invoicesList.length > 0
                                              ? _vm.invoicesList[0].currency
                                              : null
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.$root.isDesktop
                              ? _c(
                                  "md-table-cell",
                                  {
                                    staticClass: "totals-bold",
                                    attrs: { "md-numeric": "" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.totals.totalMinimumPay,
                                            _vm.invoicesList.length > 0
                                              ? _vm.invoicesList[0].currency
                                              : null
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.$root.isDesktop
                              ? _c("md-table-cell")
                              : _vm._e(),
                            _vm.$root.isDesktop
                              ? _c("md-table-cell")
                              : _vm._e(),
                            _vm.$root.isDesktop
                              ? _c(
                                  "md-table-cell",
                                  {
                                    staticClass: "totals-bold",
                                    attrs: { "md-numeric": "" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.totals.subTotal,
                                            _vm.invoicesList.length > 0
                                              ? _vm.invoicesList[0].currency
                                              : null
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.$root.isDesktop
                              ? _c(
                                  "md-table-cell",
                                  {
                                    staticClass: "totals-bold",
                                    attrs: { "md-numeric": "" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.totals.totalTax,
                                            _vm.invoicesList.length > 0
                                              ? _vm.invoicesList[0].currency
                                              : null
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "md-table-cell",
                              {
                                staticClass: "totals-bold",
                                attrs: { "md-numeric": "" },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.totals.total,
                                        _vm.invoicesList.length > 0
                                          ? _vm.invoicesList[0].currency
                                          : null
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm.$root.isDesktop
                              ? _c("md-table-cell")
                              : _vm._e(),
                            _vm.$root.isDesktop && !_vm.isReadOnlyUser
                              ? _c("md-table-cell")
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _vm.invoicesList.length === 0 && !_vm.isListLoading
                  ? _c("div", [
                      _c("p", { staticClass: "no-result-message" }, [
                        _vm._v(
                          "No results matching your search/filter could be found."
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.isListLoading
                  ? _c(
                      "div",
                      { staticClass: "content-loader loading-position" },
                      [
                        _c("fade-loader", {
                          attrs: {
                            loading: _vm.isListLoading,
                            color: "#333333",
                          },
                        }),
                        _c("span", [_vm._v("LOADING")]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _vm.total >= _vm.pagination.perPage
          ? _c(
              "md-card-actions",
              {
                staticClass: "page-footer",
                attrs: { "md-alignment": "space-between" },
              },
              [
                _c("div", {}, [
                  _c("p", { staticClass: "card-category" }, [
                    _vm._v(
                      "Showing page " +
                        _vm._s(_vm.pagination.currentPage) +
                        " of " +
                        _vm._s(_vm.maxPage)
                    ),
                  ]),
                ]),
                _c("pagination", {
                  staticClass: "pagination-no-border pagination-success",
                  attrs: {
                    "per-page": _vm.pagination.perPage,
                    total: _vm.total,
                  },
                  on: {
                    "change-page": function ($event) {
                      return _vm.handleChangePage(
                        $event,
                        _vm.pagination.perPage
                      )
                    },
                  },
                  model: {
                    value: _vm.pagination.currentPage,
                    callback: function ($$v) {
                      _vm.$set(_vm.pagination, "currentPage", $$v)
                    },
                    expression: "pagination.currentPage",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }